import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Employee, Country, Comune, Provincia, Company } from 'toolbandi-ui-lib';
import { Search, ListItem, CrudService, MessageService, SharedDataService, ListService } from 'elbuild-ui-lib-core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-employee-personal-edit',
	templateUrl: './employee-personal-edit.component.html',
	styleUrls: ['./employee-personal-edit.component.scss']
})
export class EmployeePersonalEditComponent implements OnInit, OnDestroy {


	loading: boolean = true;
	employee: Employee;

	editable: boolean = true;

	search: {
		nazione: Search,
		comune: Search,
		provincia: Search,
		company: Search
	};
	selected: {
		nazione: Country,
		comune: Comune,
		provincia: Provincia,
		company: Company
	};

	contracttypes: ListItem[] = [];
	contractlevels: ListItem[] = [];
	educationlevels: ListItem[] = [];

	nazioneClass: ClassType<Country> = Country;

	@Input()
	companyid: number;

	title: string;
	ready: { nazione: boolean; comune: boolean; provincia: boolean; company: boolean; };


	get isItalia(): boolean {
		return this.selected.nazione && this.selected.nazione.isItalia;
	}

	constructor(
		private crudService: CrudService<Employee>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private countryService: CrudService<Country>,
		private provinceService: CrudService<Provincia>,
		private comuneService: CrudService<Comune>,
		private companyService: CrudService<Company>,
		private router: Router,
		private activeModal: NgbActiveModal,
		private listService: ListService
	) {


		this.selected = {
			nazione: new Country(),
			comune: undefined,
			provincia: undefined,
			company: undefined
		};

		this.search = {
			nazione: new Search('country'),
			comune: new Search('comuni'),
			provincia: new Search('province'),
			company: new Search('company')
		};

		this.ready = {
			nazione: false,
			comune: false,
			provincia: false,
			company: false,
		};

		this.listService.getListItemsBySlug('contract.type').subscribe(data => this.contracttypes = data);
		this.listService.getListItemsBySlug('contract.level').subscribe(data => this.contractlevels = data);
		this.listService.getListItemsBySlug('education.level').subscribe(data => this.educationlevels = data);
	}

	ngOnInit() {

		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.employee = new Employee();
				this.title = 'employee-personal-create';
				if (this.companyid) {
					this.employee.companyid = this.companyid;
					this.ready.comune = true;
					this.ready.nazione = true;
					this.ready.provincia = true;
					this.findCompany(this.employee.companyid);
				} else {
					this.loading = false;
				}
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.crudService.getEntity(Employee, 'employee', id).subscribe(employee => {
			this.employee = employee;
			this.title = 'employee-personal-edit';
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.employee'));
			this.employee = undefined;
			this.loading = false;
		});
	}
	allReady(): boolean {
		return this.ready.company && this.ready.comune && this.ready.nazione && this.ready.provincia;
	}


	findCountry(name: any): void {
		if (name) {
			const countrySearch = new Search('country');
			countrySearch.addLikeFilter('name', name);
			this.countryService
				.searchEntities(Country, 'country', countrySearch, countrySearch.page)
				.subscribe((c: Country[]) => {
					this.selected.nazione = c[0];
					this.ready.nazione = true;
					if (this.allReady()) {
						this.loading = false;
					}
				});
		}
	}

	findProvince(descrizione: any): void {
		if (descrizione) {
			const provinceSearch = new Search('province');
			provinceSearch.addLikeFilter('descrizione', descrizione);
			this.provinceService
				.searchEntities(Provincia, 'province', provinceSearch, provinceSearch.page)
				.subscribe((p: Provincia[]) => {
					this.selected.provincia = p[0];
					this.ready.provincia = true;
					if (this.allReady()) {
						this.loading = false;
					}
				});
		}
	}

	findComune(descrizione: any): void {
		if (descrizione) {
			const comuneSearch = new Search('comuni');
			comuneSearch.addLikeFilter('descrizione', descrizione);
			this.comuneService
				.searchEntities(Comune, 'comuni', comuneSearch, comuneSearch.page)
				.subscribe((c: Comune[]) => {
					this.selected.comune = c[0];
					this.ready.comune = true;
					if (this.allReady()) {
						this.loading = false;
					}
				});
		}
	}

	findCompany(cid: number): void {
		if (cid) {
			this.companyService.getEntity(Company, 'company', cid).subscribe((c: Company) => {
				this.selected.company = c;
				this.ready.company = true;
				if (this.allReady()) {
					this.loading = false;
				}
			});
		}
	}

	updateCountry() {
		this.employee.province = undefined;
		this.employee.city = undefined;
		this.selected.provincia = undefined;
		this.selected.comune = undefined;
	}

	updateProvince() {
		this.selected.comune = undefined;
		this.employee.province = undefined;
		this.employee.city = undefined;

		if (this.selected.provincia) {
			this.search.comune.addSimpleFilter('provincia', this.selected.provincia.descrizione);
		}
	}

	setSelectFields() {

		this.employee.companyid = this.selected.company.id;
		this.employee.country = this.selected.nazione.name;

		if (this.selected.nazione.isItalia) {
			this.employee.province = this.selected.provincia.descrizione;
			this.employee.city = this.selected.comune.descrizione;
		}

	}

	initItem() {
		this.findCountry(this.employee.country);
		this.findProvince(this.employee.province);
		this.findComune(this.employee.city);
		this.findCompany(this.employee.companyid);
	}

	dismiss() {
		this.activeModal.dismiss();
	}


	submit() {

		this.setSelectFields();

		if (!this.employee.id) {

			this.crudService.createEntity(Employee, 'employee', this.employee).subscribe(response => {
				this.employee = response;
				const messages = this.translateService.instant(['labels.employee-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.employee-save-success'], messages['labels.success']);
				this.activeModal.close(this.employee);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.crudService.saveEntity(Employee, 'employee', this.employee).subscribe(response => {
				this.employee = response;
				this.initItem();
				const messages = this.translateService.instant(['labels.employee-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.employee-save-success'], messages['labels.success']);
				this.activeModal.close(this.employee);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}


	}

}

